/**
 * Verti DEU PL API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Key/value pair of a list
 */
export interface ListEntry {
  /**
   * Key of a list entry. In case of selecting a list entry at presentation layer, this key is usually set as value within the corresponding data structure.
   */
  key?: string;
  /**
   * Value of a list entry. Intended for display at presentation layer.
   */
  value?: string;
}
